"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopMerchantsDuration = void 0;
var TopMerchantsDuration;
(function (TopMerchantsDuration) {
    TopMerchantsDuration["PAST_WEEK"] = "pastWeek";
    TopMerchantsDuration["PAST_MONTH"] = "pastMonth";
    TopMerchantsDuration["PAST_YEAR"] = "pastYear";
})(TopMerchantsDuration || (exports.TopMerchantsDuration = TopMerchantsDuration = {}));
